import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { ANSWER_DRAG_TYPE } from './grouping-utils';
import styles from './Grouping.module.scss';

export default function GroupingDropZone({
  targetType,
  groupName = null,
  children,
  emptyLabel = 'Drag answers here',
  hasItems = false,
}) {
  const ref = useRef(null);
  const [isOver, setIsOver] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return undefined;
    }

    return dropTargetForElements({
      element: el,
      canDrop: ({ source }) => source.data?.type === ANSWER_DRAG_TYPE,
      getData: () => ({ type: targetType, groupName }),
      onDragEnter: () => setIsOver(true),
      onDragLeave: () => setIsOver(false),
      onDrop: () => setIsOver(false),
    });
  }, [groupName, targetType]);

  return (
    <div
      ref={ref}
      className={classNames(styles.dropZone, {
        [styles.dropZoneActive]: isOver,
      })}
    >
      {hasItems ? (
        children
      ) : (
        <p className={styles.dropPlaceholder}>{emptyLabel}</p>
      )}
    </div>
  );
}
